import { store } from '@/store';

const DEV_EXTRAS = 'https://md4j77w3ec3enddaou72m2wk740sdkka.lambda-url.us-east-1.on.aws';
const PROD_EXTRAS = 'https://fyothhfrqbjoipwsgdguvj4tnu0gjznt.lambda-url.us-east-1.on.aws';

export function orgExtrasBase(apiUrl = import.meta.env.VITE_APP_API_URL || ''): string {
  const configured = (import.meta.env.VITE_ORG_EXTRAS_API_URL || '').replace(/\/$/, '');
  if (configured) return configured;
  if (apiUrl.includes('crm-api-dev.rhythmsynergy.com')) return DEV_EXTRAS;
  if (apiUrl.includes('api.rhythmsynergy.com')) return PROD_EXTRAS;
  return '';
}

export function emrAccessUserIdsFromRecord(payload: unknown): string[] {
  const record =
    payload && typeof payload === 'object'
      ? (payload as { record?: { data?: unknown } }).record
      : undefined;
  const data =
    record?.data && typeof record.data === 'object'
      ? (record.data as Record<string, unknown>)
      : {};
  const ids = data.emrAccessUserIds;
  return Array.isArray(ids)
    ? ids.filter((id): id is string => typeof id === 'string' && id.length > 0)
    : [];
}

export function formatPersonName(user?: { given?: string | null; family?: string | null } | null): string {
  return [user?.given, user?.family]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
}

function authHeader(): HeadersInit {
  const token = store.getState().auth.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function loadEmrAccessNames(organizationId: string): Promise<string[]> {
  const extras = orgExtrasBase();
  const api = (import.meta.env.VITE_APP_API_URL || '').replace(/\/$/, '');
  if (!extras || !api || !organizationId) return [];

  const recordResponse = await fetch(
    `${extras}/organizations/${organizationId}/records/client-ops`,
    { headers: authHeader() },
  );
  if (!recordResponse.ok) return [];
  const ids = emrAccessUserIdsFromRecord(await recordResponse.json());
  const names = await Promise.all(
    ids.map(async (id) => {
      const userResponse = await fetch(`${api}/users/${id}`, { headers: authHeader() });
      if (!userResponse.ok) return '';
      const payload = (await userResponse.json()) as {
        user?: { given?: string | null; family?: string | null };
      };
      return formatPersonName(payload.user);
    }),
  );
  return names.filter(Boolean);
}
